const headerMenu = [
  {
    id: 'm1',
    text: 'NEW ARRIVALS',
    url: 'product-cat/new-arrivals',
  },
  {
    id: 'm2',
    text: 'BEST SELLER',
    url: 'product-cat/best-sellers',
  },
  {
    id: 'm3',
    text: 'SHOP',
    url: 'shop-all',
  },
  {
    id: 'm4',
    text: 'BACK IN STOCK',
    url: 'product-cat/back-in-stock',
  },
];

export default headerMenu;
